import React from 'react';
import { useConfig } from 'config/useConfig';
import styles from './ISRReportTable.module.scss';
import { ReactComponent as Trash } from 'img/trash.svg';
import { ReactComponent as Plus } from 'img/plus.svg';
import useModalActions from '@hooks/common/useModalAction';

export interface ISRReportTableProps {
  rows: {
    label: string;
    values: string[];
  }[];
  onAction?: (action: 'select' | 'add' | 'remove', index?: number) => void;
}

const ISRReportTable: React.FC<ISRReportTableProps> = ({ rows, onAction }) => {
  const { config } = useConfig();
  const { selectAction } = useModalActions();
  const canAddVessel = rows.some(({ label }) => !String(label ?? '').trim());

  return (
    <div className={styles.isrReport}>
      <div className={styles.isrContent}>
        <div className={styles.contentArea}>
          <div className={styles.isrHeader}>
            <div className={styles.isrTitle}>In-Stent Restenosis Calculation</div>
          </div>
          <div className={styles.isrBody}>
            <div className={styles.isrTable}>
              {rows.map(({ label, values }, index) => {
                if (!label) return null;
                return (
                  <div
                    key={`isr-${index}-${label}`}
                    className={styles.isrItems}
                    onClick={() => onAction?.('select', index)}
                  >
                    <div className={styles.item}>
                      <div className={styles.itemHeader}>
                        <div className={styles.headerTitle}>
                          <div
                            className={styles.dot}
                            style={{ backgroundColor: config.colors.isrcontent[index] }}
                          />
                          <span>{label}</span>
                        </div>
                        <div className={styles.itemData}>
                          <div className={styles.data}>
                            <span>Length</span>
                            <span>{values[0]}mm</span>
                          </div>
                          <div className={styles.data}>
                            <span>ISR(&gt;=50)</span>
                            <span
                              style={{
                                color:
                                  String(values[1]).toLowerCase() === 'true'
                                    ? '#10B981'
                                    : '#EF4444',
                              }}
                            >
                              {values[1]}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      className={styles.headerButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        selectAction('Delete selected item?', () =>
                          onAction?.('remove', index),
                        );
                      }}
                    >
                      <Trash />
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          {canAddVessel && (
            <div
              className={styles.isrFoot}
              onClick={(e) => {
                e.stopPropagation();
                onAction?.('add');
              }}
            >
              <Plus />
              <span>Add Vessel</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ISRReportTable;
